import { Component, OnInit, ViewChild, Input, Output, Inject } from '@angular/core';
import { FileUpload } from 'primeng/fileupload';
import { IdentityAuthService } from '@services/identity-auth/identity-auth.service';
import { ToastrService } from 'ngx-toastr';
import { appSettings } from '@shared/components/appSettings';
import { AppSettings } from 'src/app/entities/AppSettings';
import { Subject } from 'rxjs';
import { ConfirmationService } from 'primeng/api';;
import { ApiService } from '../../../../services/api/api.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TdDialogService } from '@covalent/core/dialogs';
import { MfControlPopupComponent } from '../../mf-control-popup/mf-control-popup.component';

@Component({
  selector: 'app-file-uploader',
  templateUrl: './file-uploader.component.html',
  styleUrls: ['./file-uploader.component.css']
})
export class FileUploaderComponent implements OnInit {
  displayName: any;
  loading: boolean = false;
  references: any;
  existingFiles: any;
  @Output() newFilesLoaded: Subject<any> = new Subject<any>();
  @ViewChild('fileUpload', { static: true }) fileUpload: FileUpload;
  uploading: boolean = false;
  public appSettings: AppSettings = appSettings;
  progress: number = 0;
  constructor(private auth: IdentityAuthService,
    private messageService: ToastrService,
    private confirmationService: ConfirmationService,
    @Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<FileUploaderComponent>, public api: ApiService, public dialogService?: TdDialogService) {
    if (data.data && data.data.references)
      this.references = data.data.references
    this.loadData();
  }

  loadData() {
    this.loading = true;
    this.api.post("/api/digitalCabinet/byReferences", this.references)
      .subscribe(data => {
        this.existingFiles = data;
        this.loading = false;
      },
        err => {
          this.loading = false;
        })
  }
  ngOnInit() {
  }

  remove(event: Event, file: any) {
    //const index: number = this.uploadedFiles.indexOf(file);
    //this.fileUpload.remove(event, index);
  }
  done() {
    this.dialogRef.close()
  }

  getFileTypeIcon(fileName) {
    switch ("." + fileName.split('.').pop().toLowerCase()) {
      case ".xlsx":
      case ".xls":
        return "fa fa-file-excel icon-excel"
      case ".zip":
        return "fa fa-file-archive"
      case ".ppx":
      case ".pptx":
        return "fa fa-file-powerpoint icon-powerpoint";
      case ".mp4":
      case ".mkv":
        return "fa fa-file-video";
      case ".wav":
      case ".mp3":
        return "fa fa-file-audio"
      case ".pdf":
        return "fa fa-file-pdf icon-pdf";
      case ".jpeg":
      case ".jpg":
      case ".png":
      case ".gif":
        return "fa fa-file-image";
      case ".doc":
      case ".docx":
        return "fa fa-file-word icon-word";
      default: return "fa fa-file";
    }
  }

  getFileType(fileName) {
    switch ("." + fileName.split('.').pop().toLowerCase()) {
      case ".xlsx":
      case ".xls":
        return "Excel"
      case ".zip":
        return "Zip"
      case ".ppx":
      case ".pptx":
        return "Powerpoint";
      case ".mp4":
      case ".mkv":
        return "Video";
      case ".wav":
      case ".mp3":
        return "Audio";
      case ".pdf":
        return "PDF";
      case ".jpeg":
      case ".jpg":
      case ".png":
      case ".gif":
        return "Image";
      case ".doc":
      case ".docx":
        return "Word";
      default: return "File";
    }
  }

  uploadFiles() {
    var _th = this;
    var fileExistCount = 0;

    if (fileExistCount > 0) {
      this.confirmationService.confirm({
        message: "There are " + fileExistCount + " file(s) that already exist. Are you sure you want to upload duplicates?",
        icon: "fa fa-exclamation-triangle",
        accept: () => {
          this.fileUpload.upload();
        }
      });

    }
    else this.fileUpload.upload();
  }
  downloadDocument(file) {
    this.api.get(`/api/digitalCabinet/downloadFile/${file.digitalCabinetDocumentId}`)
      .subscribe(fileId => {
        var links = document.createElement('a');
        document.body.appendChild(links);
        links.download = "";
        links.target = "_blank";
        links.href = `${this.appSettings.apiServiceAddress}/${fileId.url}`;
        links.click();
        document.body.removeChild(links);
      },
        err => {
          this.messageService.error("File could not be downloaded", "Action");
        });
  }
  removeDocument(file) {
    var dialogRef = this.dialogService.open(MfControlPopupComponent, {
      data: { title: 'Are you sure you want to delete?', actions: ['Delete', 'Cancel'], actionColors: ['warn', 'default'] },
    });
    var _th = this;
    dialogRef.afterClosed().subscribe(function (result) {
      if (result == 'Delete') {
        _th.loading = true;
        _th.api.post(`/api/digitalCabinet/delete/${file.id}`)
          .subscribe(o => {

            _th.messageService.success("File deleted", "Action");
            _th.loadData();
          }, err => {

              _th.loading = false;
            _th.messageService.error("File could not be deleted", "Action");
          })
      }
    });
  }
  formatDate(date): any {
    return `${date ? new Date(date)["shortDateTime"]() : ""}`
  }

  onBeforeSend(event) {
    event.formData.append('digitalCabinetReference', JSON.stringify(this.references));

    this.uploading = true;
  }

  onProgress(event) {
    this.progress = event.progress;
  }

  onUploadError(event) {
    this.messageService.error("Could not upload file", "Action");
    this.progress = 0;
    this.uploading = false;
  }

  onUpload(event) {
    this.messageService.success("Uploaded file", "Action");
    this.progress = 0;
    this.uploading = false;
    this.loadData();
  }


  removeFile(file) {
    this.fileUpload.files.splice(this.fileUpload.files.indexOf(file), 1)
  }

}
